import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { IconComponent } from '../icon/icon.component';
import {
  FOOTER_DESCRIPTION,
  FOOTER_SECTIONS,
  SOCIAL_LINKS,
  COPYRIGHT,
} from '@app/utils/constants/footer.constants';
import { IconName } from '@app/utils/enums/icon-enum';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [TranslateModule, IconComponent],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  public footerDescription = FOOTER_DESCRIPTION;
  public footerSections = FOOTER_SECTIONS;
  public socialLinks = SOCIAL_LINKS;
  public copyright = COPYRIGHT;
  public IconName = IconName;
  public currentYear = new Date().getFullYear();
}
